import packageService from '../../services/ClassenService/modules/packageService';

const state = {
  packages: [],
  packagesFacets: [],
};

const mutations = {
  SET_PACKAGES(packages) {
    state.packages = packages;
  },

  SET_PACKAGES_FACETS(facets) {
    state.packagesFacets = facets;
  }
};

const getters = {
  getPackages: (state) => () => state.packages,
  getPackagesFacets: (state) => () => state.packagesFacets,
};

const actions = {
  searchPackages: (context, {page, size, queryData}) => new Promise((resolve, reject) => {
    packageService.searchPackages(page, size, queryData)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => reject(error));
  }),

  getPackages: ({commit}) => new Promise((resolve, reject) => {
    packageService.getPackages()
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getPackage: ({commit}, packageId) => new Promise((resolve, reject) => {
    packageService.getPackage(packageId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getPackagesArticleExport: ({commit}, packageId) => new Promise((resolve, reject) => {
    packageService.getPackagesArticleExport(packageId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  updatePackage: ({commit}, packageId, packageData) => new Promise((resolve, reject) => {
    packageService.updatePackage(packageId, packageData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  deletePackage: ({commit}, packageId) => new Promise((resolve, reject) => {
    packageService.deletePackage(packageId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  addPackage: ({commit}, packageData) => new Promise((resolve, reject) => {
    packageService.addPackage(packageData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getPackagesFacets: ({commit}) => new Promise((resolve, reject) => {
    packageService.getPackagesFacets()
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getPackageAssets: ({commit}, packageId) => new Promise((resolve, reject) => {
    packageService.getPackageAssets(packageId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getPackageAsset: ({commit}, packageId, assetId) => new Promise((resolve, reject) => {
    packageService.getPackageAsset(packageId, assetId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  updatePackageAsset: ({commit}, packageId, assetId, assetData) => new Promise((resolve, reject) => {
    packageService.updatePackageAsset(packageId, assetId, assetData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  deletePackageAsset: ({commit}, packageId, assetId) => new Promise((resolve, reject) => {
    packageService.deletePackageAsset(packageId, assetId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  addPackageAsset: ({commit}, packageId, assetData) => new Promise((resolve, reject) => {
    packageService.addPackageAsset(packageId, assetData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

};

export default {
  state, mutations, getters, actions,
};
